import 'rxjs/add/operator/switchMap';
import {Component, OnInit} from '@angular/core';
import {Contest} from './core/contest';
import {DeathService} from './death.service';
import {ActivatedRoute, Params} from '@angular/router';
import {YearsMonthsDays} from './core/years-months-days';

@Component({
    moduleId: module.id,
    selector: 'contest',
    templateUrl: './contest-detail.component.html'
})

export class ContestDetailComponent implements OnInit{

    contest: Contest;

    constructor(private deathService: DeathService, private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.params
            .switchMap((params: Params) => this.deathService.getContest(+params['id']))
            .subscribe(contest => this.contest = contest);
    }

    hasAnyQualifyingDeaths(): boolean {
        let score = 0;
        this.contest.deathRecords.forEach((deathRecord) =>
            score += deathRecord.score
        )

        return score > 0;
    }

    getPeriod(ymd: YearsMonthsDays): string {
        let monthText:string = ymd.months === 1 ? 'month' : 'months';
        let dayText:string = ymd.days === 1 ? 'day' : 'days';

        return ymd.years + ' years, ' + ymd.months + ' ' + monthText + ', ' + ymd.days + ' ' + dayText;
    }
}



// WEBPACK FOOTER //
// /Users/william/Documents/gitlab/stovokor/src/app/contest-detail.component.ts